export const SET_LOADING = `SET_LOADING`;
export const SET_MESSAGE = `SET_MESSAGE`;
export const SET_ERROR = `SET_ERROR`;
export const SET_CATEGORIE = `SET_CATEGORIE`;
export const SET_ATTRIBUTES = `SET_ATTRIBUTES`;
export const SET_CATEGORIE_TITLE = `SET_CATEGORIE_TITLE`;
export const SET_ATTRIBUTES_DELETE = `SET_ATTRIBUTES_DELETE`;
